/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbSecteurGridDto
 */
export interface FcbSecteurGridDto {
    /**
     * 
     * @type {string}
     * @memberof FcbSecteurGridDto
     */
    codesecteur?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbSecteurGridDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbSecteurGridDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the FcbSecteurGridDto interface.
 */
export function instanceOfFcbSecteurGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSecteurGridDtoFromJSON(json: any): FcbSecteurGridDto {
    return FcbSecteurGridDtoFromJSONTyped(json, false);
}

export function FcbSecteurGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSecteurGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'codesecteur': !exists(json, 'codesecteur') ? undefined : json['codesecteur'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function FcbSecteurGridDtoToJSON(value?: FcbSecteurGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'codesecteur': value.codesecteur,
        'description': value.description,
        'actif': value.actif,
    };
}

